<template>
  <div class="ICMMenu--title">
    <slot />
  </div>
</template>

<script lang="ts" setup></script>

<style lang="scss" scoped>
.ICMMenu--title {
  color: #99a4a7;
  height: 32px;
  display: flex;
  align-items: center;
  padding: 0 8px;
}
</style>
